import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgHome = ({ size = "regular", className = "", ...props }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M11.517 1.926a.75.75 0 0 1 .966 0l9.5 8a.75.75 0 1 1-.966 1.148L12 3.48l-9.017 7.593a.75.75 0 0 1-.966-1.148zM5 12.25a.75.75 0 0 1 .75.75v7c0 .138.112.25.25.25h12a.25.25 0 0 0 .25-.25v-7a.75.75 0 0 1 1.5 0v7A1.75 1.75 0 0 1 18 21.75H6A1.75 1.75 0 0 1 4.25 20v-7a.75.75 0 0 1 .75-.75"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgHome;
